enum FinalCustomerContractStatus {
    Ativo = 1,
    Inativo = 2
}

export default FinalCustomerContractStatus;